var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.208193 6.02599C0.0932113 6.02599 0 5.93278 0 5.8178C0 5.70282 0.093211 5.60961 0.208193 5.60961H5.77156C5.88654 5.60961 5.97975 5.70282 5.97975 5.8178C5.97975 5.93278 5.88654 6.02599 5.77156 6.02599H0.208193ZM2.98987 8.92912C2.87489 8.92912 2.78168 8.83591 2.78168 8.72093V2.91467C2.78168 2.79969 2.87489 2.70648 2.98987 2.70648C3.10486 2.70648 3.19807 2.79969 3.19807 2.91467V8.72093C3.19807 8.83591 3.10486 8.92912 2.98987 8.92912Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4286 11.1951C10.2615 11.1951 10.126 11.0597 10.126 10.8926V0.732244C10.126 0.70918 10.1073 0.690484 10.0843 0.690484C10.0761 0.690484 10.0681 0.692889 10.0613 0.697399L7.55023 2.356C7.36737 2.47678 7.1236 2.34565 7.1236 2.12651C7.1236 2.03402 7.17008 1.94772 7.24731 1.89684L10.0095 0.0768041C10.0855 0.0267032 10.1746 0 10.2656 0C10.5227 0 10.7312 0.208435 10.7312 0.465552V10.8926C10.7312 11.0597 10.5957 11.1951 10.4286 11.1951Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneMore);
export default __webpack_public_path__ + "static/media/oneMore.87916f4f9c91d8cbc725baa1a8646826.svg";
export { ForwardRef as ReactComponent };